import { RefsVertical } from "./components/RefsVertical.js";
import { RefsModal } from "./components/RefsModal.js";
import { RefsHorizontal } from "./components/RefsHorizontal.js";
import { useState } from "react";
import { Button } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/shared/RefsByTypeTitles/index.tsx
var RefsByTypeTitles = ({ refsByType, showDetails = true, vertical = false }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	if (vertical) return /* @__PURE__ */ jsx(RefsVertical, { refsByType });
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsxs("div", {
		className: "gap-x-xs inline-flex w-auto",
		children: [/* @__PURE__ */ jsx(RefsHorizontal, { refsByType }), showDetails && /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Button, {
			onClick: () => setIsModalOpen(true),
			size: "xs",
			subtle: true,
			variant: "main",
			children: "Details"
		}) })]
	}), isModalOpen && /* @__PURE__ */ jsx(RefsModal, {
		refsByType,
		closeHandler: () => setIsModalOpen(false)
	})] });
};
//#endregion
export { RefsByTypeTitles };

//# sourceMappingURL=index.js.map